<template>
  <div :class="['creek-show', 'creek-show-' + dataShow.short_name]">
    <div class="creek-show-inner">
      <div class="creek-time-container" v-if="dataShow.Airtime">
        <div class="creek-time">
          <span class="creek-start" v-html="formatTime(dataShow.Airtime.start)"></span>
          <span class="creek-divider">&mdash;</span>
          <span class="creek-end" v-html="formatTime(dataShow.Airtime.end)"></span>
        </div>
      </div>
      <div v-if="!dataShow.group" class="creek-image-container">
        <a :href="getShowURL(dataShow)"><img v-if="dataShow.Image" :src="dataShow.Image.url_sm" /></a>
      </div>
      <div v-if="dataShow.group" class="creek-grouped-image-container">
        <a v-for="groupedShow in dataShow.group" :href="getShowURL(dataShow)" :class= "'creek-grouped-image creek-grouped-image-'+groupedShow.id"><img v-if="groupedShow.Image" :src="groupedShow.Image.url_sm" /></a>
      </div>
      <div class="creek-info-container readmore-js-section readmore-js-collapsed">
        <h3 v-if="!dataShow.group" class="creek-title"><a :href="getShowURL(dataShow)" v-text="dataShow.title"></a></h3>
        <div v-if="dataShow.group" class="creek-show-group-titles">
          <h3 class="creek-title"><span v-for="groupedShow in dataShow.group" class="creek-show-group-title"><span class="creek-show-group-titles-divider">/</span><a class="creek-show-group-title-link" :href="getShowURL(groupedShow)" :data-show-id="groupedShow.id" v-text="groupedShow.title"></a></span></h3>
        </div>
        <div class="creek-hosts-container">
          <ul>
            <li v-for="host in dataShow.hosts"><a class="creek-host-link" href="#" :href="getProfileURL(host)" v-text="host.display_name"></a></li>
          </ul>
        </div>
        <div class="creek-short-description" v-text="dataShow.short_description"></div>
        <!--
        <div class="categories">
          <div class="categories-container">
            <ul>
              <li><a href="#" class="creek-category-link" v-text="category.title"></a></li>
            </ul>
          </div>
        </div>
        -->
      </div>
      <a href="#" class="creek-readmore-js-toggle"></a>
    </div>
  </div>
</template>

<script type="text/javascript">

import fecha from 'fecha';

export default {
  name: 'creek-show',
  props: ['dataShow'],
  data () { 
    return {
    } 
  },
  methods: {
    getProfileURL (User) {
      return this.Creek.config.content.pathPrefix + '/profiles/' + User.username;
    },
    getShowURL (Show) {
      var short_name = Show.short_name || null;
      return this.Creek.config.content.pathPrefix + this.Creek.config.content.showsPath + short_name;
    },
    formatTime(time){

      var parsed = fecha.parse(time, 'HH:mm:ss');

      return fecha.format(parsed, 'h:mma');

    }
  },
  created() {

    // console.log(this.dataShow);

  }
}

</script>